import { useEffect } from 'react';
export var usePageTitle = function (title) {
    useEffect(function () {
        var baseTitle = 'Workalizer';
        var fullTitle = title ? "".concat(title, " - ").concat(baseTitle) : baseTitle;
        document.title = fullTitle;
        return function () {
            document.title = baseTitle;
        };
    }, [title]);
};
